module.exports = __webpack_public_path__ + "static/media/face.e935d489.png";